var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeHealthBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 190,
    viewBox: "0 0 361 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.191 136.251L215.191 136.248L215.12 113.724L215.117 112.727L214.12 112.727L192.584 112.727L192.584 91.1912L192.584 90.1912L191.584 90.1912L169.119 90.1912L168.119 90.1912L168.119 91.1912L168.119 112.727L146.584 112.727L145.584 112.727L145.584 113.727L145.584 136.251L145.584 137.251L146.584 137.251L168.178 137.251L168.178 158.787L168.178 159.787L169.178 159.787L191.643 159.787L192.643 159.787L192.643 158.787L192.643 137.251L214.191 137.251L214.191 136.251ZM116.357 124.971C116.357 89.8493 145.265 60.9414 180.387 60.9414C215.509 60.9414 244.417 89.8493 244.417 124.971C244.417 160.093 215.509 189.001 180.387 189.001C145.265 189.001 116.357 160.093 116.357 124.971Z",
    fill: "#ADE0DD",
    stroke: "#ADE0DD",
    strokeWidth: 2,
    className: "logo_element1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.804 114.435L346.175 119.635L346.16 119.6L346.157 119.601L333.52 124.843C328.753 114.129 287.221 28.3842 180.084 28.3842C72.7828 28.3842 31.2874 114.358 26.6246 124.89L1.31474 114.436C6.35333 102.838 54.2866 0.999999 180.06 0.999998C305.817 0.999997 353.754 102.833 358.804 114.435Z",
    fill: "#ADE0DD",
    stroke: "#ADE0DD",
    strokeWidth: 2,
    className: "logo_element2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeHealthBig);
export default __webpack_public_path__ + "static/media/SeeHealth_Big.323eab96cad0872a71b0e08fddfc6cd7.svg";
export { ForwardRef as ReactComponent };